import Menu from "./components/Menu";
import { dB64 } from "../shared/Encriptacion";
import { Link, useNavigate } from "react-router-dom";
import { HEADERS_API } from "./NuevaGuia";
import { useState, useEffect, useSyncExternalStore } from "react";
import axios from "axios";
import { mostrarAviso} from "./components/Aviso";
import Aviso from "./components/Aviso";
import { ValidarSesion } from "../shared/Validaciones";
import { ValidarLtr, ValidarNum, ValidarNumLtr } from "../shared/Regex";

export default function NuevoUsuario(){
    // ======================================================================================================
    //#region HOOKS STATE
    // ======================================================================================================
    //ESTADOS DE REGISTRO
    const[rolUsuario, setRolUsuario] = useState(0);
    const[nroDoc, setNroDoc] = useState("");
    const[nombre, setNombre] = useState("");
    const[nickname, setNickname] = useState("");
    const[clave, setClave] = useState("");
    const[claveConfirmacion, setClaveConfirmacion] = useState("");

    //ESTADOS DE CONTENIDO
    const[selectRol, setSelectRol] = useState(<></>);
    //#endregion

    //ESTADOS DE VALIDACIÓN
    const[mostrarClave, setMostrarClave] = useState(false);
    const[datosCompletos, setDatosCompletos] = useState(false);
    // ======================================================================================================
    //#region HOOKS EFFECT
    // ======================================================================================================
    useEffect(()=>{
        ValidarSesion();
        ObtenerRolesUsuario();
    },[]);

    // VALIDAR QUE LOS DATOS ESTÉN COMPLETOS
    useEffect(()=>{
        try{
            if(rolUsuario == 0 || nroDoc == "" || nombre == "" || nickname == "" 
                || clave == "" || claveConfirmacion == ""){
                throw new Error();
            }

            if(nroDoc.length < 8 || nroDoc.length > 11){
                throw new Error();
            }

            if(clave != claveConfirmacion){
                throw new Error();
            }

            if(clave.length < 6 || clave.length > 20){
                throw new Error();
            }

            HandlerDatosCompletos(true);
        }catch(error){
            HandlerDatosCompletos(false);
        }
    },[rolUsuario, nroDoc, nombre, nickname, clave, claveConfirmacion]);
    //#endregion

    // ======================================================================================================
    //#region  HOOK NAVIGATE
    // ======================================================================================================
    const navigate = useNavigate();
    //#endregion


    // ======================================================================================================
    //#region HANDLERS
    // ======================================================================================================
    //ESTADOS DE REGISTRO
    const HandlerRolUsuario = (valor) => setRolUsuario(valor);
    const HandlerNroDoc = (valor) => {
        if(ValidarNum(valor) || valor == ""){
            setNroDoc(valor);
        }
    }
    const HandlerNombre = (valor) => {
        if(ValidarLtr(valor) || valor == ""){
            setNombre(valor.toUpperCase());
        }
    }
    const HandlerNickname = (valor) => {
        if(ValidarNumLtr(valor) || valor == ""){
            setNickname(valor);
        }
    }
    const HandlerClave = (valor) => {
        if(ValidarNum(valor) || valor == ""){
            setClave(valor);
        }
    }
    const HandlerClaveConfirmacion = (valor) => {
        if(ValidarNum(valor) || valor == ""){
            setClaveConfirmacion(valor);
        }
    }

    //ESTADOS DE CONTENIDO
    const HandlerSelectRol = (lista) => {
        const listaRoles = [
            { id: "0", descripcion: "Seleccionar" },
            ...lista.map(rol => ({ id: rol.id, descripcion: rol.descripcion }))
        ];

        const listaOpciones = listaRoles.map(item => (
            <option key={item.id} value={item.id} className="text-capitalize">
                {item.descripcion.toLowerCase()}
            </option>
        ));

        setSelectRol(listaOpciones);
    }
    //#endregion

    //ESTADOS DE VALIDACIÓN
    const HandlerMostrarClave = () => {
        if(mostrarClave){
            setMostrarClave(false);
        }else{
            setMostrarClave(true);
        }
    }
    const HandlerDatosCompletos = (valor) => setDatosCompletos(valor);
    //#endregion

    // ======================================================================================================
    //#region FUNCIONES
    // ======================================================================================================
    // FUNCIONES ASÍNCRONAS
    const ObtenerRolesUsuario = async () => {
        try{
            let response = await axios.get(URL_ROLES_USUARIO,{
                headers: HEADERS_API
            }).catch(error => {
                throw new Error(error.message);
            });

            HandlerSelectRol(response.data.lista);
        }catch(error){
            console.log(error);
        }
    }
    const RegistrarUsuario = async () => {
        try{
            let response = await axios.post(URL_INSERTAR_USUARIO, {
                codigoUsuario: "",
                codigoRegistrar: nroDoc,
                nombre: nombre,
                nickname: nickname,
                clave: clave,
                rol: rolUsuario
            }, {
                headers: HEADERS_API
            }).catch(error => {
                throw new Error(error.response.data);
            });
            navigate("/usuarios");
        }catch(error){
            mostrarAviso(error, 2500);
        }
    }
    // FUNCIONES COMPLEMENTARIAS

    //#endregion

    // ======================================================================================================
    //#region CONTENIDO
    // ======================================================================================================
    return(<>
    <Menu/>
    <Aviso/>
    <div className="container">
        <div className="row">
            <div className="col-12 py-2 border-bottom border-secondary text-secondary text-center text-md-start">
                <h2>{dB64(localStorage.getItem('r6'))}</h2>
            </div>
            <div className='col-12 p-3 text-secondary'>
                <Link className='' to={'/usuarios'}>
                    <button className='btn btn-secondary'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-return-left" 
                        viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M14.5 1.5a.5.5 0 0 1 .5.5v4.8a2.5 2.5 0 0 1-2.5 2.5H2.707l3.347 3.346a.5.5 0 0 1-.708.708l-4.2-4.2a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 8.3H12.5A1.5 1.5 0 0 0 14 6.8V2a.5.5 0 0 1 .5-.5"/>
                        </svg>
                        <span className='mx-2'>Regresar</span>
                    </button>
                </Link>
            </div> 
            <div className='col-12 pb-2 fs-3 fw-semibold'>
                NUEVO USUARIO
            </div>
            <div className="col-12 col-md-6">
                <div className="p-1">
                    <label className="form-label fw-semibold" htmlFor="rol-usuario">Perfil</label>
                    <select onChange={e=>HandlerRolUsuario(e.target.value)} id="rol-usuario" className="form-select text-capitalize">
                        {selectRol}
                    </select>
                </div>
                <div className="p-1">
                    <label className="form-label fw-semibold" htmlFor="codigo-usuario">N° Documento</label>
                    <input onChange={e=>HandlerNroDoc(e.target.value)} value={nroDoc} maxLength={11} type="text" className="form-control" id="codigo-usuario" autoComplete="off" />
                    <div className="form-text">Debe contener entre 8 y 11 caracteres</div>
                </div>
                <div className="p-1">
                    <label className="form-label fw-semibold" htmlFor="nombre-usuario">Nombre Completo</label>
                    <input onChange={e=>HandlerNombre(e.target.value)} value={nombre} maxLength={120} type="text" className="form-control text-uppercase" id="nombre-usuario" autoComplete="off" />
                </div>
            </div>
            <div className="col-12 col-md-6">
                <div className="p-1">
                    <label className="form-label fw-semibold" htmlFor="nickname-usuario">ID de Usuario</label>
                    <input onChange={e=>HandlerNickname(e.target.value)} value={nickname} maxLength={50} type="text" className="form-control" id="nickname-usuario" autoComplete="off" />
                    <div className="form-text">Nombre que el usuario ingresará para identificarse en la plataforma</div>
                </div>
                <div className="p-1">
                    <label className="form-label fw-semibold" htmlFor="clave-usuario">Contraseña</label>
                    <input onChange={e=>HandlerClave(e.target.value)} value={clave} maxLength={20} type={mostrarClave ? "text" : "password"} className="form-control" id="clave-usuario" />
                    <div className="form-text">Debe contener entre 6 y 20 caracteres</div>
                </div>
                <div className="p-1">
                    <label className="form-label fw-semibold" htmlFor="confirmar-clave-usuario">Confirmar Contraseña</label>
                    <input onChange={e=>HandlerClaveConfirmacion(e.target.value)} value={claveConfirmacion} maxLength={20} type={mostrarClave ? "text" : "password"} className="form-control" id="confirmar-clave-usuario" />
                </div>
                <div className="p-1 d-flex justify-content-end">
                    <div className="form-check">
                        <input onChange={HandlerMostrarClave} checked={mostrarClave} className="form-check-input" type="checkbox" id="mostrar-clave"/>
                        <label className="form-check-label" htmlFor="mostrar-clave">
                        Mostrar Contraseñas
                        </label>
                    </div>
                </div>
            </div>
            <div className="col-12 py-3 d-flex justify-content-center align-items-center">
                <button onClick={RegistrarUsuario} disabled={!datosCompletos} className="btn btn-primary">Registrar Usuario</button>
            </div>
        </div>
    </div>
    </>)

    //#endregion
}

// ======================================================================================================
//#region CONSTANTES
// ======================================================================================================
const URL_ROLES_USUARIO = process.env.REACT_APP_URL_ROLES_USUARIO;
const URL_INSERTAR_USUARIO = process.env.REACT_APP_URL_INSERTAR_USUARIO;
//#endregion